import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CaretDown, CaretUp, DotsThreeCircle, Trash } from '@phosphor-icons/react'

import { Alert, ButtonMenu, IconButton, InputWithLabel, ScrollableTabs, Text, ToastContext } from '@reveni-io/reveni-ui'

import { languages as constantsLanguage } from '@/common/constants'
import { getCurrentAvailableLanguage } from '@/configuration/helpers/helpers'

import * as Styles from './styles'

const SubReason = ({ info, onDelete, languages = [], onEditSubReasonDisplay, onEditSubReasonInternalName }) => {
  const { t, i18n } = useTranslation()
  const { setToastInfo } = useContext(ToastContext)
  const [isOpen, setIsOpen] = useState(true)
  const [titleErrors, setTitleErrors] = useState({})
  const currentLanguage = getCurrentAvailableLanguage(languages, i18n.language)
  const [textLanguage, setTextLanguage] = useState(currentLanguage)
  const [presentationalInternalName, setPresentationalInternalName] = useState(info.internal_name)
  const [presentationalKey, setPresentationalKey] = useState(info.key)

  const getLanguageLabel = language => {
    return constantsLanguage(t).find(lang => lang.value === language)?.label
  }

  const handleOnBlurTitle = () => {
    languages.forEach(lang => {
      setTitleErrors(errors => ({ ...errors, [lang]: info?.display?.[lang] ? false : true }))
    })
  }

  const updatePresentationalStates = () => {
    setPresentationalInternalName(info.internal_name)
    setPresentationalKey(info.key)
  }

  const handleDelete = () => {
    onDelete(info.id)
    setToastInfo({ show: true, message: 'Submotivo eliminado correctamente', type: 'success' })
  }

  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.HeaderLeft>
          <Text type="titleS">{presentationalInternalName}</Text>
          <IconButton
            onClick={() => setIsOpen(open => !open)}
            variant="text"
            icon={isOpen ? <CaretUp size={24} weight="light" /> : <CaretDown size={24} weight="light" />}
          />
        </Styles.HeaderLeft>
        <ButtonMenu
          renderButton={onClick => (
            <IconButton onClick={onClick} variant="text" icon={<DotsThreeCircle weight="light" size={24} />} />
          )}
          menuItems={[
            {
              label: (
                <Styles.MenuItemContainer onClick={handleDelete}>
                  <Trash /> {t('Eliminar')}
                </Styles.MenuItemContainer>
              ),
            },
          ]}
        />
      </Styles.Header>
      {isOpen && (
        <>
          <div>
            <Styles.BasicInfoContainer>
              <Text type="bodyMRegular">
                {t(
                  'Define el nombre interno con el que se podrá reconocer el submotivo (ejemplo: “Los colores no coinciden”).'
                )}
              </Text>
              <InputWithLabel
                onChange={e => onEditSubReasonInternalName(e.target.value, info?.id)}
                backgroundColor="white"
                label={t('Nombre interno')}
                value={info.internal_name}
                onBlur={updatePresentationalStates}
              />
              <Alert type="info">
                {t('El identificador interno se verá así')}: <strong>{presentationalKey}</strong>
              </Alert>

              <Text type="bodyMRegular">
                {t('Define el nombre del submotivo que verá el cliente en el portal de devoluciones')}:
              </Text>
            </Styles.BasicInfoContainer>
          </div>
          <div>
            <ScrollableTabs
              tabs={languages.map(language => ({
                label: getLanguageLabel(language),
                value: language,
                error: titleErrors?.[language],
              }))}
              value={textLanguage}
              onChange={setTextLanguage}
            />
            <InputWithLabel
              onChange={e => onEditSubReasonDisplay(e.target.value, info?.id, textLanguage)}
              value={info?.display?.[textLanguage] || ''}
              maxLength={128}
              onBlur={handleOnBlurTitle}
              backgroundColor="white"
              fullWidth
            />
          </div>
        </>
      )}
    </Styles.Container>
  )
}

export default SubReason
